module.exports = __webpack_public_path__ + "img/vertical_7_5_7016.46274dc3.png";